module.exports = __webpack_public_path__ + "static/media/SellerboxFunction02.6b25d931.png";